export const LABEL = 'Items in this module';
export const EMPTY = 'No module items.';
